export default "__VITE_ASSET__DUmt1af1__"